if (!customElements.get("color-swatch")) {
	window.qlAllProductds = {};
	class ColorSwatch extends HTMLElement {
	  constructor() {
		super();
	  }
  
	  connectedCallback() {
		this.optionNodes = this.querySelectorAll("[data-value]");
		this.handles = JSON.parse(this.getAttribute('data-array-handles'));   //合并货号数组
		this.handle = this.getAttribute('data-swatch-handle');                           //当前货号
		const label = this.getAttribute('data-swatch-label').trim().toLowerCase();       //颜色属性名
		this.colorGroup = this.getAttribute('data-color-group')?.toLowerCase() ?? 'color';	//颜色分组名
    this.count = 0;   // 颜色个数
		this.colorOption = {};
		this.colorOption.name = this.label;
		this.colorOption.values = [];
		this.swatchesEl = new DocumentFragment();

    if(this.handles && this.handles.length > 0){
		  Promise.all(
			this.handles && this.handles.map((h) => {
			  return new Promise((resolve, reject) => {
				if(window.qlAllProductds[h]){
				  let product = window.qlAllProductds[h];
				  this.colorSwatches(this, product);
		  
				 resolve();
				}else{
				  this.fetchProduct(h).then((product) => {
					window.qlAllProductds[h] = product;
					this.colorSwatches(this, product);
			
				   resolve();
				  });
				}
				
			  })
			})
		  ).then(() => {
			this.appendChild(this.swatchesEl);
      // 剩余颜色数量
      if(this.count > 4){
        let countBtn = document.createElement('a');
        countBtn.classList.add('color-swatch__count', 'focus-inset', 'btn', 'btn--plain', 'btn-rest');
        countBtn.href = '/products/' + this.handle;
        countBtn.innerHTML = `<span>+${this.count - 4}</span>`;
        this.appendChild(countBtn);
      }
			if (this.colorOption) {
			  this.swatches = this.colorOption.values;
			  this.init();
			}
		  })
		}


	  }

    // 新建颜色swatches
    colorSwatches(container, product){
      const label = container.getAttribute('data-swatch-label') ? container.getAttribute('data-swatch-label').trim().toLowerCase(): 'color';
      // 颜色对应的分组
      let color_group_name = product && product.tags.filter((tag) => {
        return tag.indexOf("Colorgroup_") != -1;
      });
      color_group_name = color_group_name.length > 0 ? color_group_name[0].replace("Colorgroup_","")?.toLowerCase() : "color";
  
      if(this.colorGroup !== color_group_name) return;
  
      var colorObj = {};
      product && (colorObj =  product.options.find((element) => {
        return element.name.toLowerCase() === label || null;
      }));
  
  
      colorObj && container.colorOption.values.concat(colorObj.values) ;
  
      var len = colorObj && colorObj.values ? colorObj.values.length : 0;
      for(let i = 0 ; i < len; i++){
        var o = colorObj.values[i];
        // 颜色对应variant
        for (let x = 0; x < product.variants.length; x++) {
          var v = product.variants[x];
          var vrOpt = v.options;
          if (vrOpt.indexOf(o) !== -1) {
  
            container.optionWithValues = {
              value: o,
              image: v.featured_image && v.featured_image.src,
              variant: v,
              position: o ? o.position : 1
            };
            break;
          }
        }
  
        var html = document.createElement('a');
        html.classList.add('color-swatch__item','focus-inset');
        html.setAttribute('data-swatch-button','');
        html.setAttribute('data-tippy-theme','color-');
        html.setAttribute('data-tippy-content',o);
        html.setAttribute('data-value',o);
        html.setAttribute('title',o);
        html.setAttribute('href',`${product.url}?variant=${container.optionWithValues.variant.id}`);
        html.setAttribute('data-option-position',1);
        html.innerHTML = `<span class="visually-hidden">${o}</span>`;
        html.style = `--animation-delay: ${(100 * this.count) / 1000}s`;

        // 颜色
        const {colorSwatches = []} = window.FoxThemeSettings
			  const str_custom_colors = window.FoxThemeSettings.custom_colors
			  const custom_colors = str_custom_colors.replace('\n', '').split(',')
			  const optionValue = o;
			  const customColor = colorSwatches.find(c => c.key.toLowerCase() === optionValue.toLowerCase())
        if(customColor && customColor.value.indexOf('.png') !== -1){
          const bg = window.location.origin + '/cdn/shop/files/' + customColor.value;
          html.style.setProperty('background-image', `url(${bg})`)
        }else{
          html.style.setProperty('--swatch-background', `${customColor ?  customColor.value : optionValue.split(' ').pop().toLowerCase()}`)
        }

        // 颜色对应的媒体图
        if(container.optionWithValues.image){
          html.setAttribute(
            "data-src",
            getSizedImageUrl(container.optionWithValues.image, "900x")
          );
          html.setAttribute("data-srcset", getSrcset(container.optionWithValues.image));
        }

        container.swatchesEl.appendChild(html);
        this.count++;
  
      }
  
      }
    

    fetchProduct(handle) {
      const requestRoute = `${window.location.origin}/products/${handle}.js`;
    
      return window
      .fetch(requestRoute)
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
    }
  
	  disconnectedCallback() {
		this.optionNodes.forEach((button) =>
		  button.removeEventListener("mouseenter", this.onMouseEnter.bind(this))
		);
	  }
  
	  init() {
      this.optionNodes = this.querySelectorAll("[data-value]");
		const productCard = this.closest(".product-card");
		this.mainImage = productCard.querySelector(
		  ".product-card__image--main img"
		);
		this.optionNodes.forEach((button) =>
		  button.addEventListener("mouseenter", this.onMouseEnter.bind(this))
		);
  
		this.selected = this.querySelector('a[aria-selected="true"]');
  
		this.getVariantData();
		this.initOptionSwatches();
	  }
  
	  initOptionSwatches() {
		this.optionNodes.forEach((optNode) => {
		  let variantImage;
		  const { optionPosition, value: optionValue } = optNode.dataset;
		  const variant = this.variantData.find(
			(v) =>
			  v[`option${optionPosition}`] &&
			  v[`option${optionPosition}`].toLowerCase() ===
				optionValue.toLowerCase()
		  );
		  if (variant) {
			variantImage = variant.featured_image
			  ? variant.featured_image.src
			  : "";
			optNode.href = `${optNode.href}?variant=${variant.id}`;
			if (variantImage) {
			  optNode.setAttribute(
				"data-src",
				getSizedImageUrl(variantImage, "900x")
			  );
			  optNode.setAttribute("data-srcset", getSrcset(variantImage));
			}
		  }
		});
	  }
  
	  onMouseEnter(e) {
		const { target } = e;
		this.selected && this.selected.removeAttribute("aria-selected");
		target.setAttribute("aria-selected", true);
  
		const { src, srcset } = target.dataset;
		if (this.mainImage && srcset) {
		  this.mainImage.src = src;
		  this.mainImage.srcset = srcset;
		}
  
		this.selected = target;
	  }
  
	  getVariantData() {
		this.variantData =
		  this.variantData || JSON.parse(this.nextElementSibling.textContent);
	  }
	}
	customElements.define("color-swatch", ColorSwatch);
  }
  